import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader } from '@livable/saas-react-components';
import { Button, Grid, TextField, Typography } from '@mui/material';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { utilitySetupNewCustomProvider, utilitySetupNewCustomProviderSchema } from 'src/utils/formValidation/AddNewProperty';
import { useFormik } from 'formik';
// import { useStore } from 'src/stores';
import useStyles from './styles';
export const GetForm = _ref => {
  let handleModalClose = _ref.handleModalClose;
  const classes = useStyles();
  // const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _React$useState = React.useState('custom'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    type = _React$useState2[0],
    setType = _React$useState2[1];
  const handlePlanChange = event => {
    setType(event.target.value);
  };
  const addNewProviderFormik = useFormik({
    initialValues: utilitySetupNewCustomProvider,
    onSubmit: async () => {},
    validationSchema: utilitySetupNewCustomProviderSchema
  });
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form,
    onSubmit: addNewProviderFormik.handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: false
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Please select what credential issue you are facing"), /*#__PURE__*/React.createElement(RadioGroup, {
    value: type,
    onChange: handlePlanChange,
    className: classes.addCustomBillingControllWrapper
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => setType('custom'),
    className: classes.addCustomBillingControll
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "custom",
    control: /*#__PURE__*/React.createElement(Radio, null)
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Wrong credentials")), /*#__PURE__*/React.createElement("div", {
    onClick: () => setType('old'),
    className: classes.addCustomBillingControll
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "old",
    control: /*#__PURE__*/React.createElement(Radio, null)
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Credentials expired")), /*#__PURE__*/React.createElement("div", {
    onClick: () => setType('old'),
    className: classes.addCustomBillingControll
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "old",
    control: /*#__PURE__*/React.createElement(Radio, null)
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "The answer for the security issues is wrong")), /*#__PURE__*/React.createElement("div", {
    onClick: () => setType('old'),
    className: classes.addCustomBillingControll
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "old",
    control: /*#__PURE__*/React.createElement(Radio, null)
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "The website link doesn't work"))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "name",
    name: "name",
    label: "Add note",
    variant: "outlined",
    fullWidth: true,
    multiline: true,
    value: addNewProviderFormik.values.name,
    onBlur: e => {
      if (e.target.value) addNewProviderFormik.handleBlur(e);
    },
    onChange: e => {
      addNewProviderFormik.handleChange(e);
    },
    error: addNewProviderFormik.touched.name && Boolean(addNewProviderFormik.errors.name),
    helperText: addNewProviderFormik.touched.name && addNewProviderFormik.errors.name
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '517-ReportCredentialsIssueModal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    'custom-attribute': '518-ReportCredentialsIssueModal'
  }, "Report credentials issue"))))));
};